import { render, staticRenderFns } from "./Segmento.vue?vue&type=template&id=ea463ac6&scoped=true"
import script from "./Segmento.vue?vue&type=script&lang=js"
export * from "./Segmento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea463ac6",
  null
  
)

export default component.exports